import { useEffect, useState } from "react";
import { useFirestore } from "react-redux-firebase";
import { parseDate } from "../helpers/parser";
import {
  ATTENDEES_COLLECTION,
  buildNextEventStats,
  EVENTS_COLLECTION,
  NextEventStat,
} from "./shared";

type NextEventState = {
  nextEventStats: NextEventStat[];
  nextEventDate: string;
};

const EMPTY_STATE: NextEventState = {
  nextEventStats: [],
  nextEventDate: "Intet event fundet",
};

const useNextEventStats = (): NextEventState => {
  const firestore = useFirestore();
  const [state, setState] = useState<NextEventState>(EMPTY_STATE);

  useEffect(() => {
    let isSubscribed = true;

    async function fetchNextEvent() {
      try {
        const eventsRef = firestore.collection(EVENTS_COLLECTION);
        const events = await eventsRef
          .where("date", ">", new Date())
          .where("completed", "==", false)
          .orderBy("date", "asc")
          .limit(1)
          .get();

        if (!isSubscribed) {
          return;
        }

        const infoEvent = events.docs[0];

        if (!infoEvent) {
          setState(EMPTY_STATE);
          return;
        }

        const attendeesSnapshot = await infoEvent.ref
          .collection(ATTENDEES_COLLECTION)
          .get();

        if (!isSubscribed) {
          return;
        }

        setState({
          nextEventStats: buildNextEventStats(
            attendeesSnapshot.docs
              .filter((doc) => doc.exists)
              .map((doc) => doc.data() as Attendee)
          ),
          nextEventDate: parseDate(infoEvent.data().date, "MMM Do"),
        });
      } catch (error) {
        console.error(error);
      }
    }

    fetchNextEvent();

    return () => {
      isSubscribed = false;
    };
  }, [firestore]);

  return state;
};

export default useNextEventStats;
